// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3fYhS","label":"LabeledBox_label__l8mrB"};